module.exports = __webpack_public_path__ + "static/media/img15.7f8f06fb.jpeg";